import React from 'react';
import { Chip, Stack, Typography } from '@mui/material';
import { ATTENDANCE_TIMING_TAGS } from '../utils/attendanceLabels';

interface AttendanceTimingLegendProps {
  compact?: boolean;
  showNote?: boolean;
}

const AttendanceTimingLegend: React.FC<AttendanceTimingLegendProps> = ({
  compact = false,
  showNote = true,
}) => (
  <Stack direction="row" spacing={0.5} flexWrap="wrap" useFlexGap alignItems="center">
    {ATTENDANCE_TIMING_TAGS.map((tag) => (
      <Chip
        key={tag.key}
        label={compact ? tag.shortLabel : tag.label}
        size="small"
        sx={{
          height: compact ? 18 : 22,
          fontSize: compact ? '0.6rem' : '0.65rem',
          fontWeight: 600,
          bgcolor: tag.color,
          color: tag.textColor,
          '& .MuiChip-label': { px: compact ? 0.6 : 0.85 },
        }}
      />
    ))}
    {showNote && !compact && (
      <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.65rem' }}>
        (auto unless supervisor approves absence · includes not scheduled agents)
      </Typography>
    )}
  </Stack>
);

export default AttendanceTimingLegend;
